"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _BatchSet = _interopRequireDefault(require("../modules/BatchSet.vue"));
var _GoodsAttrbuit = _interopRequireDefault(require("../modules/GoodsAttrbuit.vue"));
var _common = require("../common");
var _api = require("../api");
var _MainImage = _interopRequireDefault(require("../modules/MainImage.vue"));
var _enum = require("../../enum");
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var couponApi = _interopRequireWildcard(require("@/views/marketing/coupon/api"));
var _systemSetting = require("@/api/systemSetting");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'SpecificationsAndInventory',
  components: {
    BatchSetVue: _BatchSet.default,
    GoodsAttrbuit: _GoodsAttrbuit.default,
    MainImageVue: _MainImage.default
  },
  props: {
    cloneForm: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      formConfig: _common.formConfig,
      comData: _common.comData,
      rules: _common.rules,
      isAddRule: false,
      addRuleForm: {},
      selectRuleList: [],
      form: {},
      ID: this.$route.params.id,
      lock: true,
      goodsStatusEnum: _enum.goodsStatusEnum,
      cpStatusEnum: _enum.cpStatusEnum,
      couponSkuInfo: {},
      couponList: []
    };
  },
  watch: {
    form: {
      handler: function handler(newVal, oldVal) {
        this.$emit('formChange', newVal);
        // console.log('form changed:', newVal, oldVal);
        // 在这里编写你需要的逻辑
      },
      deep: true
    },
    cloneForm: {
      handler: function handler(newForm) {
        var _this2 = this;
        console.log('cloneForm更新:', newForm);
        this.form = _objectSpread({}, newForm);
        if (this.ID && this.form.attr && this.lock) {
          var _this$form$attrValue;
          this.lock = false;
          console.log('编辑模式：从attr初始化规格列表', this.form.attr);
          this.selectRuleList = this.form.attr.map(function (item) {
            var _item$attrValues;
            return {
              value: item.attrName,
              detail: item === null || item === void 0 ? void 0 : (_item$attrValues = item.attrValues) === null || _item$attrValues === void 0 ? void 0 : _item$attrValues.split(','),
              inputVisible: false
            };
          });

          // 确保编辑模式下保留原始的 attrValue
          console.log('编辑模式：保留原始 attrValue 数据', (_this$form$attrValue = this.form.attrValue) === null || _this$form$attrValue === void 0 ? void 0 : _this$form$attrValue.length);

          // 延迟触发属性列的更新，确保GoodsAttrbuit组件已加载
          this.$nextTick(function () {
            _this2.createAttrProps();
          });
        }
        if (newForm.productType == 3) {
          var _ref = newForm || {},
            _ref$attrValue = _ref.attrValue,
            attrValue = _ref$attrValue === void 0 ? [] : _ref$attrValue;
          this.couponSkuInfo = _objectSpread(_objectSpread({
            couponId: newForm === null || newForm === void 0 ? void 0 : newForm.couponId
          }, (attrValue === null || attrValue === void 0 ? void 0 : attrValue.length) && attrValue[0]), this.couponSkuInfo);
        }
      }
    },
    selectRuleList: {
      handler: function handler() {
        console.log('selectRuleList变化，当前模式:', this.ID ? '编辑' : '新建');
        this.createAttrProps();

        // 无论是新建还是编辑模式，都需要重新创建属性值组合
        this.createAttrValue();
        this.submitAttr();
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.searchCoupon();

    // 在编辑模式下确保规格数据正确初始化
    if (this.ID) {
      console.log('编辑模式初始化:', this.ID);
      // 如果是编辑模式且表单数据已加载
      if (this.form.attr && this.form.attr.length > 0 && (!this.selectRuleList || this.selectRuleList.length === 0)) {
        console.log('从attr初始化规格列表');
        this.selectRuleList = this.form.attr.map(function (item) {
          var _item$attrValues2;
          return {
            value: item.attrName,
            detail: item === null || item === void 0 ? void 0 : (_item$attrValues2 = item.attrValues) === null || _item$attrValues2 === void 0 ? void 0 : _item$attrValues2.split(','),
            inputVisible: false
          };
        });
      }
    }
  },
  methods: {
    throttle: _throttle.default,
    getRule: _common.getRule,
    validate: function () {
      var _validate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var requiredFields, errorFields, _i, _requiredFields, item, value, errorMsg, formData, isEditMode, _errorMsg, _errorMsg2, _errorMsg3, _errorMsg4, isValid, _errorMsg5, _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              console.log('开始验证规格库存表单');
              console.log('当前产品类型:', this.cloneForm.productType);
              if (!(this.cloneForm.productType == 3)) {
                _context.n = 2;
                break;
              }
              // 优惠券表单验证逻辑保持不变
              console.log('验证优惠券表单数据:', this.couponSkuInfo);
              requiredFields = [{
                field: 'couponId',
                name: '优惠券名称'
              }, {
                field: 'suk',
                name: '规格名称'
              }, {
                field: 'skuName',
                name: 'SKU名称'
              }, {
                field: 'skuCode',
                name: 'SKU编码'
              }, {
                field: 'attrImage',
                name: '规格图片'
              }, {
                field: 'image',
                name: '主图管理',
                isArray: true
              }, {
                field: 'otPrice',
                name: '原价'
              }, {
                field: 'supplyPrice',
                name: '供货价'
              }, {
                field: 'guidePrice',
                name: '指导价'
              }, {
                field: 'defaultPrice',
                name: '默认售价'
              }, {
                field: 'stock',
                name: '库存数量'
              }, {
                field: 'stockWarning',
                name: '库存预警量'
              }, {
                field: 'cpStatus',
                name: '采销状态'
              }, {
                field: 'listStatus',
                name: '上下架状态'
              }, {
                field: 'barCode',
                name: '条形码'
              }];
              errorFields = [];
              for (_i = 0, _requiredFields = requiredFields; _i < _requiredFields.length; _i++) {
                item = _requiredFields[_i];
                value = this.couponSkuInfo[item.field];
                if (item.field === 'image' || item.isArray) {
                  if (!value || !Array.isArray(value) || value.length === 0) {
                    errorFields.push(item.name);
                  }
                } else if (value === undefined || value === null || value === '') {
                  errorFields.push(item.name);
                }
              }
              if (!(errorFields.length > 0)) {
                _context.n = 1;
                break;
              }
              errorMsg = "\u8BF7\u586B\u5199\u4EE5\u4E0B\u5FC5\u586B\u9879: ".concat(errorFields.join(', '));
              console.error('优惠券表单验证失败:', errorMsg);
              this.$message.error(errorMsg);
              return _context.a(2, Promise.reject(new Error(errorMsg)));
            case 1:
              formData = _objectSpread({}, this.form);
              formData.couponId = this.couponSkuInfo.couponId;
              formData.attrValue = [this.couponSkuInfo];
              this.form = formData;
              console.log('优惠券表单验证通过');
              return _context.a(2, Promise.resolve());
            case 2:
              console.log('验证普通商品规格库存');
              // 判断是否为编辑模式
              isEditMode = !!this.ID;
              console.log('当前模式:', isEditMode ? '编辑模式' : '新建模式');

              // 验证规格数据
              if (!(!isEditMode && !this.form.selectRule)) {
                _context.n = 3;
                break;
              }
              // 只在新建模式下要求选择规格
              _errorMsg = '请选择规格';
              console.error('规格库存验证失败:', _errorMsg);
              this.$message.error(_errorMsg);
              return _context.a(2, Promise.reject(new Error(_errorMsg)));
            case 3:
              if (!(!this.form.attrValue || this.form.attrValue.length === 0)) {
                _context.n = 4;
                break;
              }
              _errorMsg2 = '请添加商品规格数据';
              console.error('规格库存验证失败:', _errorMsg2, this.form);
              this.$message.error(_errorMsg2);
              return _context.a(2, Promise.reject(new Error(_errorMsg2)));
            case 4:
              if (!isEditMode) {
                _context.n = 6;
                break;
              }
              console.log('编辑模式下检查规格数据:', this.selectRuleList);
              // 编辑模式下必须有规格列表数据
              if (!(!this.selectRuleList || this.selectRuleList.length === 0)) {
                _context.n = 6;
                break;
              }
              if (!(this.form.attr && this.form.attr.length > 0)) {
                _context.n = 5;
                break;
              }
              console.log('从attr重建规格列表');
              this.selectRuleList = this.form.attr.map(function (item) {
                var _item$attrValues3;
                return {
                  value: item.attrName,
                  detail: item === null || item === void 0 ? void 0 : (_item$attrValues3 = item.attrValues) === null || _item$attrValues3 === void 0 ? void 0 : _item$attrValues3.split(','),
                  inputVisible: false
                };
              });
              _context.n = 6;
              break;
            case 5:
              _errorMsg3 = '编辑模式下缺少规格数据';
              console.error('规格库存验证失败:', _errorMsg3);
              this.$message.error(_errorMsg3);
              return _context.a(2, Promise.reject(new Error(_errorMsg3)));
            case 6:
              // 使用GoodsAttrbuit组件的验证方法
              console.log('开始验证商品属性表格');
              if (this.$refs.GoodsAttrbuitRef) {
                _context.n = 7;
                break;
              }
              _errorMsg4 = 'GoodsAttrbuit组件未初始化';
              console.error('规格库存验证失败:', _errorMsg4);
              this.$message.error(_errorMsg4);
              return _context.a(2, Promise.reject(new Error(_errorMsg4)));
            case 7:
              isValid = this.$refs.GoodsAttrbuitRef.validate();
              if (isValid) {
                _context.n = 8;
                break;
              }
              _errorMsg5 = '商品规格验证不通过';
              console.error('规格库存验证失败:', _errorMsg5);
              return _context.a(2, Promise.reject(new Error(_errorMsg5)));
            case 8:
              _context.p = 8;
              // 验证表单字段
              console.log('验证规格库存基本表单');
              _context.n = 9;
              return this.$refs.formRef.validate();
            case 9:
              console.log('规格库存验证全部通过');
              return _context.a(2, Promise.resolve());
            case 10:
              _context.p = 10;
              _t = _context.v;
              console.error('规格库存表单验证失败:', _t);
              return _context.a(2, Promise.reject(_t));
            case 11:
              _context.n = 13;
              break;
            case 12:
              _context.p = 12;
              _t2 = _context.v;
              console.error('规格库存验证过程中出现异常:', _t2);
              return _context.a(2, Promise.reject(_t2));
            case 13:
              return _context.a(2);
          }
        }, _callee, this, [[8, 10], [0, 12]]);
      }));
      function validate() {
        return _validate.apply(this, arguments);
      }
      return validate;
    }(),
    confirm: function confirm() {
      this.selectRuleList = _toConsumableArray(this.form.selectRule.ruleValue);
    },
    handleInputConfirm: function handleInputConfirm(item) {
      item.inputValue && item.detail.indexOf(item.inputValue) === -1 && item.detail.push(item.inputValue);
      this.$set(item, 'inputVisible', false);
      this.$set(item, 'inputValue', '');
    },
    showInput: function showInput(index) {
      var _this3 = this;
      this.$set(this.selectRuleList[index], 'inputVisible', true);
      this.$nextTick(function () {
        _this3.$refs.saveTagInput[0].$refs.input.focus();
      });
    },
    handleTagNameClose: function handleTagNameClose(index) {
      this.selectRuleList.splice(index, 1);
    },
    handleTagClose: function handleTagClose(index, tagItem) {
      var target = this.selectRuleList[index].detail.indexOf(tagItem);
      this.selectRuleList[index].detail.splice(target, 1);
    },
    /**
     * 添加规格
     */
    addRule: function addRule() {
      var _this = this;
      var params = {
        ruleName: '',
        ruleValue: []
      };
      this.$modalAttr(params, function () {
        _this.getRule();
      });
    },
    addRuleItem: function addRuleItem() {
      var volidata = this.addRuleForm.attrName && this.addRuleForm.attrValue;
      if (!volidata) {
        this.$message.warning('请输入规格和规格值');
        return;
      }
      var newAttr = {
        inputVisible: false,
        value: this.addRuleForm.attrName,
        detail: [this.addRuleForm.attrValue]
      };
      if (this.ID) {
        var _this$selectRuleList;
        // 编辑模式下的处理
        console.log('编辑模式：添加新规格项', newAttr);
        if ((_this$selectRuleList = this.selectRuleList) !== null && _this$selectRuleList !== void 0 && _this$selectRuleList.length) {
          // 检查是否已存在相同规格名称
          var existingRuleIndex = this.selectRuleList.findIndex(function (rule) {
            return rule.value === newAttr.value;
          });
          if (existingRuleIndex !== -1) {
            // 如果规格名称已存在，将规格值添加到现有规格中
            if (!this.selectRuleList[existingRuleIndex].detail.includes(newAttr.detail[0])) {
              this.selectRuleList[existingRuleIndex].detail.push(newAttr.detail[0]);
              console.log('编辑模式：向现有规格添加新值');
            } else {
              this.$message.warning('该规格值已存在');
              return;
            }
          } else {
            // 如果是全新的规格名称，添加到列表中
            this.selectRuleList.push(newAttr);
            console.log('编辑模式：添加全新规格');
          }
        } else {
          this.selectRuleList = [newAttr];
          console.log('编辑模式：初始化规格列表');
        }

        // 强制触发watch更新
        this.selectRuleList = _toConsumableArray(this.selectRuleList);
      } else {
        var _this$form, _this$form$selectRule;
        // 新建模式下的处理
        this.form.selectRule.ruleValue.push(newAttr);
        this.selectRuleList = _toConsumableArray((_this$form = this.form) === null || _this$form === void 0 ? void 0 : (_this$form$selectRule = _this$form.selectRule) === null || _this$form$selectRule === void 0 ? void 0 : _this$form$selectRule.ruleValue);
      }
      this.addRuleForm.attrName = '';
      this.addRuleForm.attrValue = '';
      this.isAddRule = false;
      console.log('规格添加完成，当前规格列表:', this.selectRuleList);
    },
    clear: function clear() {
      this.selectRuleList = [];
    },
    clearInit: function clearInit() {
      this.couponSkuInfo = {};
    },
    /**
     * 求规格数组的笛卡儿积
     * @param arrays 规格数组
     */
    generateCombinations: function generateCombinations(attributes) {
      if (attributes.length === 0) {
        return [];
      }

      // 初始化结果数组
      var result = [];

      // 辅助函数，用于递归生成组合
      function helper(prefix, remainingAttrs) {
        if (remainingAttrs.length === 0) {
          // 当没有剩余属性时，结束递归并生成最终对象
          var combination = _objectSpread(_objectSpread({
            cpMinQuantity: 50,
            stock: 9999,
            stockWarning: 50,
            cpStatus: 3,
            listStatus: 1
          }, prefix), {}, {
            attrValue: _objectSpread({}, prefix)
          });
          result.push(combination);
          return;
        }

        // 取出第一个属性
        var _remainingAttrs = _toArray(remainingAttrs),
          firstAttr = _remainingAttrs[0],
          restAttrs = _arrayLikeToArray(_remainingAttrs).slice(1);

        // 遍历第一个属性的所有可能值
        firstAttr.detail.forEach(function (detail) {
          // 为每个可能值调用递归，以生成后续属性的组合
          helper(_objectSpread(_objectSpread({}, prefix), {}, _defineProperty({}, firstAttr.value, detail)), restAttrs);
        });
      }

      // 开始递归处理
      helper({}, attributes);
      return result;
    },
    createAttrProps: function createAttrProps() {
      var _this$$refs, _this$selectRuleList2;
      var _ref2 = ((_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : _this$$refs.GoodsAttrbuitRef) || {},
        updataAttrProps = _ref2.updataAttrProps;
      var attrProps = (_this$selectRuleList2 = this.selectRuleList) === null || _this$selectRuleList2 === void 0 ? void 0 : _this$selectRuleList2.map(function (item) {
        return {
          label: item.value,
          prop: item.value // 历史原因此处是中文
        };
      });
      updataAttrProps && updataAttrProps(attrProps);
    },
    createAttrValue: function createAttrValue() {
      if (this.ID) {
        // 编辑模式下，需要智能合并新增的规格组合
        var _compose = this.generateCombinations(this.selectRuleList);
        if (_compose && _compose.length > 0) {
          // 获取现有的attrValue，保留已填写的数据
          var existingAttrValue = this.form.attrValue || [];

          // 合并新旧规格组合，保留原有数据
          var mergedAttrValue = this.getNewAttrValue(_compose);
          this.$set(this.form, 'attrValue', mergedAttrValue);

          // 只为新增的规格项生成SKU编码
          this.getSkuCodeForNewItems(_compose, existingAttrValue);
        }
        return;
      }
      // 新建模式下生成所有可能的规格组合
      var compose = this.generateCombinations(this.selectRuleList);
      this.$set(this.form, 'attrValue', compose);
      this.getSkuCodeColum();
    },
    getNewAttrValue: function getNewAttrValue(compose) {
      var _this4 = this;
      var result = [];
      var attrValues = this.form.attrValue.map(function (item) {
        return JSON.stringify(item.attrValue);
      });
      compose.forEach(function (item) {
        var index = attrValues.indexOf(JSON.stringify(item.attrValue));
        if (index === -1) {
          result.push(item);
        } else {
          result.push(_this4.form.attrValue[index]);
        }
      });
      return result;
    },
    //获取sku编码
    getSkuCodeColum: function () {
      var _getSkuCodeColum = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var spuCode, list, res, _t3;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!this.ID) {
                _context2.n = 1;
                break;
              }
              console.log('编辑模式：跳过SKU编码生成');
              return _context2.a(2);
            case 1:
              spuCode = this.form.spuCode;
              list = this.form.attrValue.map(function (item) {
                var attributeName = '';
                for (var key in item.attrValue) {
                  attributeName = "".concat(attributeName).concat(item.attrValue[key]);
                }
                return {
                  spuCode: spuCode,
                  attributeName: attributeName
                };
              });
              _context2.p = 2;
              _context2.n = 3;
              return (0, _api.buchGenerateSKUCodeApi)({
                list: list
              });
            case 3:
              res = _context2.v;
              this.form.attrValue = this.form.attrValue.map(function (j, i) {
                return _objectSpread(_objectSpread({}, j), {}, {
                  skuCode: "".concat(res[i].code).concat(res[i].extraNum)
                });
              });
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t3 = _context2.v;
              this.$message.error(_t3);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 4]]);
      }));
      function getSkuCodeColum() {
        return _getSkuCodeColum.apply(this, arguments);
      }
      return getSkuCodeColum;
    }(),
    // 编辑模式下为新增的规格项生成SKU编码
    getSkuCodeForNewItems: function () {
      var _getSkuCodeForNewItems = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(newCompose, existingAttrValue) {
        var spuCode, existingAttrValues, newItems, list, res, newItemIndex, _t4;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              spuCode = this.form.spuCode;
              existingAttrValues = existingAttrValue.map(function (item) {
                return JSON.stringify(item.attrValue);
              }); // 找出新增的规格组合
              newItems = newCompose.filter(function (item) {
                return existingAttrValues.indexOf(JSON.stringify(item.attrValue)) === -1;
              });
              if (!(newItems.length === 0)) {
                _context3.n = 1;
                break;
              }
              console.log('编辑模式：没有新增的规格项');
              return _context3.a(2);
            case 1:
              console.log('编辑模式：为', newItems.length, '个新增规格项生成SKU编码');
              list = newItems.map(function (item) {
                var attributeName = '';
                for (var key in item.attrValue) {
                  attributeName = "".concat(attributeName).concat(item.attrValue[key]);
                }
                return {
                  spuCode: spuCode,
                  attributeName: attributeName
                };
              });
              _context3.p = 2;
              _context3.n = 3;
              return (0, _api.buchGenerateSKUCodeApi)({
                list: list
              });
            case 3:
              res = _context3.v;
              // 更新form.attrValue中新增项的SKU编码
              newItemIndex = 0;
              this.form.attrValue = this.form.attrValue.map(function (item) {
                var isNewItem = existingAttrValues.indexOf(JSON.stringify(item.attrValue)) === -1;
                if (isNewItem && newItemIndex < res.length) {
                  var updatedItem = _objectSpread(_objectSpread({}, item), {}, {
                    skuCode: "".concat(res[newItemIndex].code).concat(res[newItemIndex].extraNum)
                  });
                  newItemIndex++;
                  return updatedItem;
                }
                return item;
              });
              console.log('编辑模式：SKU编码生成完成');
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t4 = _context3.v;
              console.error('编辑模式：SKU编码生成失败', _t4);
              this.$message.error('SKU编码生成失败: ' + _t4);
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this, [[2, 4]]);
      }));
      function getSkuCodeForNewItems(_x, _x2) {
        return _getSkuCodeForNewItems.apply(this, arguments);
      }
      return getSkuCodeForNewItems;
    }(),
    updataAttrValue: function updataAttrValue(data) {
      var _this5 = this;
      // 只更新有值的数据
      this.form.attrValue = this.form.attrValue.map(function (item) {
        for (var key in data) {
          if (data[key] || data[key] === 0) {
            if (key == 'image') {
              var _data$image;
              item.image = (_data$image = data['image']) !== null && _data$image !== void 0 && _data$image.length ? data['image'] : item.image;
            } else {
              _this5.$set(item, key, data[key]);
            }
          }
        }
        return item;
      });
    },
    submitAttr: function submitAttr() {
      var _this$selectRuleList3;
      // 更新attr信息，但不重新生成attrValue
      this.form.attr = (_this$selectRuleList3 = this.selectRuleList) === null || _this$selectRuleList3 === void 0 ? void 0 : _this$selectRuleList3.map(function (item) {
        var _item$detail;
        return _objectSpread(_objectSpread({}, item), {}, {
          attrName: item.value,
          attrValues: (_item$detail = item.detail) === null || _item$detail === void 0 ? void 0 : _item$detail.join(',')
        });
      });

      // 如果在编辑模式下，确保不会修改原始attrValue结构
      if (this.ID) {
        console.log('编辑模式：保持原始attrValue结构，仅更新属性名对应');
      }
    },
    searchCoupon: function searchCoupon() {
      var _this6 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.couponList = [];
      couponApi.couponslistApi({
        page: 1,
        limit: 50,
        name: keyword
      }).then(function (res) {
        _this6.couponList = (res === null || res === void 0 ? void 0 : res.list) || [];
      });
    },
    handleCouponSearch: function handleCouponSearch(data) {
      var _this7 = this;
      this.throttle(function () {
        _this7.searchCoupon(data);
      }, 300)();
    },
    attrImage: function attrImage() {
      var _this = this;
      // 创建一个隐藏的文件输入框
      var input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*'; // 只接受图片类型

      // 处理文件选择事件
      input.onchange = function (e) {
        var files = e.target.files;
        if (!files || !files.length) {
          return;
        }
        var file = files[0]; // 只处理第一个文件

        // 验证文件类型
        if (!file.type.startsWith('image/')) {
          _this.$message.error('请选择图片文件！');
          return;
        }

        // 显示上传中的loading状态
        var loadingInstance = _this.$loading({
          lock: true,
          text: '图片上传中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        // 创建FormData对象用于上传
        var formData = new FormData();
        formData.append('multipart', file);

        // 设置上传参数 - 调用指定的接口
        var params = {
          model: 'product',
          // 使用product模块
          pid: 1 // 使用指定的pid
        };

        // 调用API上传图片
        (0, _systemSetting.fileImageApi)(formData, params).then(function (response) {
          if (response && response.url) {
            // 上传成功，添加到图片列表
            _this.$set(_this.couponSkuInfo, 'attrImage', response.url);
            _this.$message.success('图片上传成功');
          } else {
            _this.$message.error("\u6587\u4EF6 ".concat(file.name, " \u4E0A\u4F20\u5931\u8D25: \u670D\u52A1\u5668\u8FD4\u56DE\u9519\u8BEF"));
          }
        }).catch(function (error) {
          console.error('Upload error:', error);
          _this.$message.error("\u6587\u4EF6 ".concat(file.name, " \u4E0A\u4F20\u5931\u8D25: ").concat(error.message || '未知错误'));
        }).finally(function () {
          loadingInstance.close();
        });
      };

      // 触发文件选择对话框
      input.click();
    },
    handleMainImage: function handleMainImage() {
      this.$refs.mainImageRef.open(this.couponSkuInfo.image);
    },
    mainImageList: function mainImageList(data) {
      this.$set(this.couponSkuInfo, 'image', data);
    },
    changeCoupon: function changeCoupon() {
      if (!this.couponSkuInfo.couponId) {
        this.searchCoupon();
      }
    }
  }
};